import type { ThemeProviderProps } from "./theme.type";

import { ConfigProvider, App } from "antd";
import { memo, useMemo } from "react";

import { useAppLocale } from "@/services/language";

import {
  THEME_CLASSNAME_PREFIX,
  THEME_CONFIG,
  THEME_TRANSLATIONS,
} from "./theme.constant";
import { generateCustomCssVariables } from "./theme.helper";

import "./theme.style.less";

const ThemeProviderComponent = ({ children }: ThemeProviderProps) => {
  const locale = useAppLocale();

  const translations = useMemo(
    () => THEME_TRANSLATIONS[locale] ?? THEME_TRANSLATIONS.default,
    [locale]
  );

  return (
    <ConfigProvider
      prefixCls={THEME_CLASSNAME_PREFIX}
      theme={THEME_CONFIG}
      locale={translations}
    >
      <style>{generateCustomCssVariables(THEME_CONFIG)}</style>
      <App>{children}</App>
    </ConfigProvider>
  );
};

export const ThemeProvider = memo(ThemeProviderComponent);
